import { WalletEnquiry } from "../model/payments/payments";
import { apiSlice } from "../stores/base/api-slice";
const walletEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getWalletEnquiry: builder.query<WalletEnquiry, void>({
			query: () => ({
				url: `/virtual-wallet/account/enquiry`,
				method: "GET",
			}),
		}),
		payInitialDepositWithWallet: builder.mutation<{ status: string }, string>({
			query: orderId => ({
				url: `/virtual-wallet/charge/deposit/${orderId}`,
				method: "POST",
			}),
		}),
		payInstallmentWithWallet: builder.mutation<{ status: string }, string>({
			query: orderId => ({
				url: `/virtual-wallet/charge/${orderId}`,
				method: "POST",
			}),
		}),
		payRemainderWithWallet: builder.mutation<{ status: string }, string>({
			query: orderId => ({
				url: `/virtual-wallet/charge/remainder/${orderId}`,
				method: "POST",
			}),
		}),
		verifyWalletPayment: builder.query<{ reference: string, status: string}, string>({
			query: reference =>({
				url: `/virtual-wallet/verify-transaction/${reference}`,
				method: "GET",
			})
		})
	}),
});
export const { 
	useLazyGetWalletEnquiryQuery, 
	usePayInitialDepositWithWalletMutation, 
	usePayInstallmentWithWalletMutation, 
	usePayRemainderWithWalletMutation, 
	useLazyVerifyWalletPaymentQuery 
} =
	walletEndpoints;
